<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="创建人">
                <a-input v-model="queryParam.extendS1" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="作品名称">
                <a-input v-model="queryParam.workName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.cuttingStatus" style="width: 100%" allow-clear>
                  <a-select-option :value="0"> 未开始 </a-select-option>
                  <a-select-option :value="1"> 进行中 </a-select-option>
                  <a-select-option :value="2"> 已完成 </a-select-option>
                  <a-select-option :value="3"> 失败 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced && userType == 0">
              <a-form-item label="企业">
                <a-input v-model="queryParam.tenantFirmName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced && userType == 1">
              <a-form-item label="经销商">
                <a-input v-model="queryParam.tenantName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime" />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(1)"
          v-hasPermi="['af330eef6ac25a09871497fa84912364b:0:c']" v-if="!vrWorkId">
          新增
        </a-button>
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd(1)"
          v-hasPermi="['af330eef6ac25a09871497fa84912364b:0:c']" v-if="vrWorkId == 1">
          批量解绑
        </a-button>
        <a-button type="primary" @click="$refs.createForm.handleAdd(1)"
          v-hasPermi="['87aaa547b70e66f84176d5cc3528701bc:1:c']" v-if="vrWorkId == 2">
          确认选择
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="workId"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        class="center-table">
        <span slot="workName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.workName">
            <span class="text-ellipsis">{{ record.workName || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="tenantFirmName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.tenantFirmName">
            <span class="text-ellipsis">{{ record.tenantFirmName || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="tenantName" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.tenantName">
            <span class="text-ellipsis" v-if="record.tenantId !== record.tenantFirmId">{{ record.tenantName || '--'
            }}</span>
            <span v-else>--</span>
          </a-tooltip>
        </span>
        <span slot="coverImageUrl" slot-scope="text, record">
          <div v-viewer v-if="record.coverImageUrl">
            <img :src="$url + record.coverImageUrl" alt="" style="width: 50px; height: 50px" />
          </div>
          <span v-else>--</span>
        </span>
        <span slot="shareLogoUrl" slot-scope="text, record">
          <div v-viewer v-if="record.shareLogoUrl">
            <img :src="$url + record.shareLogoUrl" alt="" style="width: 50px; height: 50px" />
          </div>
          <span v-else>--</span>
        </span>
        <span slot="supplementMapUrl" slot-scope="text, record">
          <div v-viewer v-if="record.supplementMapUrl">
            <img :src="$url + record.supplementMapUrl" alt="" style="width: 50px; height: 50px" />
          </div>
          <span v-else>--</span>
        </span>
        <span slot="cuttingStatus" slot-scope="text, record">
          <a-tag :color="getCuttingStatusColor(record.cuttingStatus)">
            <span v-if="record.cuttingStatus == 0">未开始</span>
            <span v-if="record.cuttingStatus == 1">进行中</span>
            <span v-if="record.cuttingStatus == 2">已完成</span>
            <span v-if="record.cuttingStatus == 3">失败</span>
          </a-tag>
        </span>
        <span slot="backgroundMusicUrl" slot-scope="text, record">
          <div v-if="record.backgroundMusicUrl" style="width: 100px">
            <audio ref="audio" style="width: 200px" :src="$url + record.backgroundMusicUrl" controls></audio>
            <a-button
              @click="$refs.vrDetail.handleUpdate(record, undefined)"
              v-hasPermi="['af330eef6ac25a09871497fa84912364q:0:q']">
              试听
            </a-button>
          </div>
        </span>
        <span slot="cuttingStatus" slot-scope="text, record">
          <span v-if="record.cuttingStatus == 0">未开始</span>
          <span v-if="record.cuttingStatus == 1">进行中</span>
          <span v-if="record.cuttingStatus == 2">已完成</span>
          <span v-if="record.cuttingStatus == 3">失败</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a
            @click="$refs.vrDetail.handleUpdate(record, undefined)"
            v-hasPermi="['af330eef6ac25a09871497fa84912364q:0:q']">
            详情
          </a>
          <a-divider type="vertical" v-hasPermi="['af330eef6ac25a09871497fa84912364q:0:q']" />
          <a-dropdown v-hasPermi="['af330eef6ac25a09871497fa84912364q:0:q', 'af330eef6ac25a09871497fa84912364r:0:r']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['af330eef6ac25a09871497fa84912364r:0:r']">
                <a @click="handleDelete(record)" v-hasPermi="['af330eef6ac25a09871497fa84912364r:0:r']"> 删除 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['af330eef6ac25a09871497fa84912364r:1:t']">
                <a
                  @click="handleRetry(record)"
                  v-if="record.cuttingStatus == 3"
                  v-hasPermi="['af330eef6ac25a09871497fa84912364r:1:t']">
                  重试切图
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <span slot="extendS1" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.extendS1">
              <span class="text-ellipsis">{{ record.extendS1 || '--' }}</span>
            </a-tooltip>
          </span>
          <span slot="createTime" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.createTime">
              <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
            </a-tooltip>
          </span>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize" />
    </a-card>
    <detail ref="vrDetail"></detail>
    <CreateForm ref="createForm" @ok="getList"></CreateForm>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj, retryObj } from '@/api/VR/vrWork'
import detail from './model/details.vue'
import CreateForm from './model/CreateForm.vue'
import { listTenant } from '@/api/system/tenant'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'Work',
  components: {
    detail,
    CreateForm,
  },
  props: {
    vrWorkId: {
      type: [String, Number],
    },
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    ...mapGetters(['userTentant', 'infoUser']),
  },
  data() {
    return {
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      value: [],
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      tableSize: 'default',
      tableBordered: true,
      selectedRowKeys: [],
      columns: [
        {
          title: '作品名称',
          dataIndex: 'workName',
          key: 'workName',
          align: 'center',
          scopedSlots: { customRender: 'workName' },
          width: '120px',
        },
        {
          title: '企业',
          dataIndex: 'tenantFirmName',
          width: '100px',
          align: 'center',
          scopedSlots: { customRender: 'tenantFirmName' },
        },
        {
          title: '经销商',
          width: '100px',
          dataIndex: 'tenantName',
          scopedSlots: { customRender: 'tenantName' },
          key: 'tenantName',
          align: 'center',
        },
        {
          title: '封面图',
          dataIndex: 'coverImageUrl',
          width: '75px',
          scopedSlots: { customRender: 'coverImageUrl' },
          align: 'center',
        },
        {
          title: '分享图',
          key: 'shareLogoUrl',
          width: '75px',
          scopedSlots: { customRender: 'shareLogoUrl' },
          align: 'center',
        },
        {
          title: '补地图',
          width: '75px',
          key: 'supplementMapUrl',
          scopedSlots: { customRender: 'supplementMapUrl' },
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'cuttingStatus',
          align: 'center',
          key: 'cuttingStatus',
          width: '80px',
          scopedSlots: { customRender: 'cuttingStatus' },
        },
        {
          title: '创建人',
          dataIndex: 'extendS1',
          key: 'extendS1',
          align: 'center',
          scopedSlots: { customRender: 'extendS1' },
          width: '100px',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '120px',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: '160px',
        },
      ],
    }
  },
  methods: {
    // 获取切图状态颜色
    getCuttingStatusColor(status) {
      const colorMap = {
        0: 'default', // 未开始
        1: 'blue', // 进行中
        2: 'green', // 已完成
        3: 'red', // 失败
      }
      return colorMap[status] || 'default'
    },

    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.workId || this.ids
      if (row.workId) {
        ids = [{ workId: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ workId: v })
        })
      }
      console.log(ids, '的点点滴滴')
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            // that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() { },
      })
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'vr/works/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },
    onChangeTime(e) {
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleRetry(row) {
      var that = this
      this.$confirm({
        title: '是否确认重试切图?',
        onOk() {
          return retryObj({ workId: row.workId }).then(() => {
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() { },
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
  },
  created() {
    if (this.vrWorkId) {
      this.columns.pop()
    }
    if (this.userType == 1) {
      this.columns.splice(1, 1)
    }
    if (this.userType == 2) {
      this.columns.splice(2, 1)
    }
    console.log(this.userType, 'userTypeuserType')
    this.getList()
  },
}
</script>
<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-wrapper .ant-form-item {
  margin-bottom: 16px;
}

.center-table .ant-table-thead>tr>th {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-tbody>tr>td {
  text-align: center;
  white-space: nowrap;
}

.center-table .ant-table-thead>tr>th,
.center-table .ant-table-tbody>tr>td {
  vertical-align: middle;
}

.ant-table-pagination {
  margin-top: 16px;
  text-align: center;
}

.center-table {
  width: 100%;
}

.center-table .ant-table-container {
  width: 100%;
}

.center-table .ant-table-content {
  text-align: center;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.action-right {
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
}

/* 图片样式优化 */
.center-table img {
  max-width: 50px;
  max-height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

/* 状态标签样式 */
.ant-tag {
  margin: 0;
  white-space: nowrap;
}
</style>
